import { render, staticRenderFns } from "./BackerCenterRecentlyViewedProjectsSkeleton.vue?vue&type=template&id=4caf96e6"
import script from "./BackerCenterRecentlyViewedProjectsSkeleton.vue?vue&type=script&lang=js"
export * from "./BackerCenterRecentlyViewedProjectsSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports